import * as React from 'react';
import 'matchmedia-polyfill';
import 'matchmedia-polyfill/matchMedia.addListener';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box, MuiBox, Typography } from '@kis-technologies/kis-ui';
import { useStyles } from './styled';

interface TextSliderProps {
  height: string;
  width: string;
  items: any;
  name?: string;
  isInactive?: boolean;
  fontFamily?: any;
  transitionTime?: number;
}

export const TextSlider = (props: TextSliderProps) => {
  const { height, width, items, name, isInactive, fontFamily, transitionTime } = props;

  const classes = useStyles({ fontFamily })();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: transitionTime ? true : false,
    autoplaySpeed: transitionTime ? transitionTime * 1000 : 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
    pauseOnHover: false
  };

  return (
    <div style={{ height, width }}>
      <Slider {...settings}>
        {items &&
          Object.keys(items).map((key) => {
            if (isInactive) {
              return (
                <>
                  {/* Inactive page */}
                  <Typography className={classes.inactiveHeader}>{items[key].header}</Typography>
                  <MuiBox className={classes.box} />
                  <Typography className={classes.inactiveSubheader}>
                    <Box>{items[key].subheader}</Box>
                  </Typography>
                </>
              );
            }
            return (
              <>
                {/* Attract loop page */}
                <p>{items[key].header}</p>
                {/* Display the (client) name if header is not configured */}
                {!items[key].isCongfigured && <p>{name}</p>}
                <MuiBox className={classes.box} />
                <p className={classes.attractSubheader}>{items[key].subheader}</p>
              </>
            );
          })}
      </Slider>
    </div>
  );
};
